/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable vars-on-top */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable arrow-body-style */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Box } from "@material-ui/core";
import clsx from "clsx";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import {useLocation } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DOMPurify from "dompurify";
import { setLogin } from "../../redux/features/auth/actions";
import TataMotors from "../../assets/images/tatamotors.png";
import styles from "./LandingPage.module.css";
import Truckloading from "../../components/CvLoader/Cvloader";
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";

function Announcement({landingpageRight}) {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const location = useLocation();
  const baseUrl = useSelector((state) => state.counter.baseUrl);
  const [announcementData,setAnnouncementData]=useState([])
  const [isMobile, setIsMobile] = useState(false);
  const [path, setPath] = useState("");
  const [loading, setLoading] = React.useState(false)


  useEffect(() => {
    const isMobileDevice = /Mobi/.test(window.navigator.userAgent);
    if (isMobileDevice) {
      setIsMobile(isMobileDevice);
    } else {
      setIsMobile(false);
    }
  }, [isMobile]);

  useEffect(() => {
    if (location.pathname == "/") {
      setPath("/home");    
    } else {
      setPath(location.pathname);
    }
  }, [location]);


  const AnnouncementCount =async()=>{
    setLoading(true)
    try {
      const apiFormatedData = {      
        "co_code":sanitizeCoCodeNumeric(auth.companyCode),
       "pers_no":sanitizeNumeric(auth.personNumber)
      };
      // eslint-disable-next-line no-var   
      const response = await apiService.getAnnouncements(apiFormatedData, dispatch);
      dispatch(setLogin({...auth, recentStatus: response.status}))
      setLoading(false) 
      if(response.msg === "Success" ){
        setLoading(false)
        setAnnouncementData(response.data)
      } 
      
    } catch (error) {
      setLoading(false)
    } finally{
      setLoading(false)
    }
  }
  
  useEffect(()=>{
    AnnouncementCount()
  },[])
  return (
    <>
     <div className={clsx(
      styles.scrollContainer,
      styles.scrollBar,
      styles.formContainer
    )}>
          <Grid container className={styles.announcement_container}>
        <Grid
          item
          md={12}
          lg={12}
          xs={12}
          style={{ background: "white", marginTop: "3px" ,padding:"10px",position:"relative",}}
        >
          <Box>
            <span>
              <MenuBookIcon style={{ color: "#316BA3" }} />
            </span>
            <label style={{marginTop:"5px",position:"absolute",marginLeft:"15px"}}> <span>Announcement</span></label>
            <span style={{ float: "right" }}>
              <ArrowForwardIcon style={{ color: "rgb(33, 98, 172)" }} />
            </span>
          </Box>
          <hr />
        </Grid>
        {announcementData?.map((item) => {
            const sanitizedHtml = DOMPurify.sanitize(
              item.announcementtext || ""
            );
          return (
            <>
            {item.imagelink !== null ? 
              <Grid item md={landingpageRight ? 1 : 3} lg={landingpageRight ? 1 : 3} xs={landingpageRight ? 1:3} style={{ marginTop: "3px",padding:"3px 11px" }}>

                  <img
                  className={styles.imageheight}
                  src={TataMotors}
                  alt="Tata Motors"            
                />
              </Grid>
              : 
              ''
            }
              <Grid item md={landingpageRight ? 11 : item.imagelink !== null ? 9 : 12} lg={landingpageRight ? 11 : item.imagelink !== null ? 9 : 12} xs={landingpageRight ? 11 : item.imagelink !== null ? 9 : 12} className={styles.notificationpadding}>          
                <div
                    style={{ fontSize: "12px", lineHeight: 1.5 }}
                    dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                  />
              </Grid>
            </>
          );
        })}
         {loading==true ? 
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"10px",background:"white", boxShadow:"0px 3px 6px #00000027"}}>
               <Truckloading />
            </div>:''} 
      </Grid>

    </div>
    
    </>
  );
}

export default Announcement;